<template>
  <div>
    <h1>表单submit事件</h1>
    <p>用表单，候选词不会触发搜索</p>
    <form
      class="d-flex align-center"
      @submit="handleSubmit"
    >
      <v-text-field
        v-model="value"
        label="请输入"
        dense
        outlined
        hide-details
        style="max-width: 200px;"
        class="mr-2"
      />
      <v-btn
        class="mr-2"
      >
        查询
      </v-btn>
      <div>目前状态: {{ status }}</div>
    </form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: '',
      status: '输入中'
    }
  },
  methods: {
    handleSubmit() {
      this.status = '查询中' + this.value
      setTimeout(() => {
        this.status = '查询成功'
        setTimeout(() => {
          this.reset()
        }, 1000)
      }, 1000)
    },
    reset() {
      this.value = ''
      this.status = '输入中'
    }
  }
}
</script>

<style scoped>
</style>